import * as React from 'react'
import {
    Route,
    Switch,
    useRouteMatch,
} from 'react-router-dom';
import { ChangeRequestsPage } from '@app/SecretManager/ChangeRequests/view/ChangeRequestsPage'
import { ChangeRequestPage } from '@app/SecretManager/ChangeRequests/view/ChangeRequestPage'
import { ChangeRequestCreationPage } from '@app/SecretManager/ChangeRequests/view/ChangeRequestCreationPage'
import { ClusterSelection } from '../../../SecretManager/common/ClusterSelection';


export const ChangeRequestIndex: React.FunctionComponent = () => {
    const { path } = useRouteMatch();

    return (<>
        <Switch>
            <Route path={`${path}`} exact={true}>
                <ChangeRequestsPage clusterSelector={<ClusterSelection />} />
            </Route>
            <Route path={`${path}/create`} exact={true}>
                <ClusterSelection />
                <ChangeRequestCreationPage root={path} />
            </Route>
            <Route path={`${path}/view/:request_id`} exact={false}>
                <ClusterSelection />
                <ChangeRequestPage root={path} />
            </Route>
        </Switch>

    </>)
}
